/**
 * Slideshow helpers: next-section scroll (single hero) + progress-bar carousel navigation.
 */
document.addEventListener(
  'click',
  function (e) {
    const btn = e.target.closest('[data-mmk-slideshow-next]');
    if (!btn) return;
    const section = btn.closest('.shopify-section');
    section?.nextElementSibling?.scrollIntoView({ block: 'start', behavior: 'smooth' });
  },
  { passive: true }
);

function updateSlideshowCarouselNavigation(nav, index) {
  const count =
    parseInt(nav.dataset.slideCount, 10) ||
    nav.querySelectorAll('.slideshow__carousel-navigation-segment').length;

  if (!count) return;

  nav.style.setProperty('--slideshow-nav-progress', (index + 1) / count);
}

function initSlideshowCarouselNavigation(nav) {
  if (nav.dataset.mmkNavInit === 'true') return;
  nav.dataset.mmkNavInit = 'true';

  const carousel = document.getElementById(nav.getAttribute('aria-controls'));
  if (!carousel) return;

  const segments = nav.querySelectorAll('.slideshow__carousel-navigation-segment');
  const selectedIndex = Array.from(segments).findIndex(
    (button) => button.getAttribute('aria-current') === 'true'
  );

  updateSlideshowCarouselNavigation(nav, Math.max(selectedIndex, 0));

  carousel.addEventListener('carousel:change', (event) => {
    updateSlideshowCarouselNavigation(nav, event.detail.index);
  });
}

function initSlideshowCarouselNavigations(root = document) {
  root.querySelectorAll('.slideshow__carousel-navigation').forEach(initSlideshowCarouselNavigation);
}

function slideshowNextSectionIsHidden(section) {
  const next = section.nextElementSibling;
  if (!next) return false;
  return getComputedStyle(next).display === 'none';
}

function syncSlideshowNextHiddenSpacing() {
  document.querySelectorAll('.shopify-section--slideshow').forEach((section) => {
    section.classList.toggle('slideshow-section--next-hidden', slideshowNextSectionIsHidden(section));
  });
}

function observeSlideshowNextHiddenSpacing() {
  syncSlideshowNextHiddenSpacing();
  if (window.__mmkSlideshowNextHiddenObserver) return;

  const observer = new MutationObserver((mutations) => {
    const relevant = mutations.some((mutation) => {
      if (mutation.type === 'attributes') {
        return mutation.target.classList?.contains('shopify-section');
      }

      return [...mutation.addedNodes, ...mutation.removedNodes].some(
        (node) => node.nodeType === 1 && node.classList?.contains('shopify-section')
      );
    });

    if (relevant) syncSlideshowNextHiddenSpacing();
  });

  observer.observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['style', 'hidden'],
  });

  window.__mmkSlideshowNextHiddenObserver = observer;
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initSlideshowCarouselNavigations();
    observeSlideshowNextHiddenSpacing();
  });
} else {
  initSlideshowCarouselNavigations();
  observeSlideshowNextHiddenSpacing();
}

document.addEventListener('shopify:section:load', (event) => {
  initSlideshowCarouselNavigations(event.target);
  syncSlideshowNextHiddenSpacing();
});
